import {
  FIELDS_INIT,
  NOTIFICATION_CONFIG,
  NOTIFICATION_CONFIG_INIT,
  NOTIFICATION_EVENTS,
  NOTIFICATION_MODAL_TYPE,
  MESSAGES,
  WHATSAPP_TEMPLATE_TYPES,
  NOTIFICATION_MESSAGES_BODY,
  WHATSAPP_DOCUMENT_CATEGORY
} from "../../constants/NotificationConstants";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import InitialConfiguration from "./components/InitialConfiguration/InitialConfiguration.vue";
import MessageConfiguration from "./components/MessageConfiguration/MessageConfiguration.vue";
import MessageRecipients from "@/shared/components/MessageRecipients/MessageRecipients.vue";
import { NotificationConfig } from "../../models/NotificationConfig";
import { NotificationTemplate } from "../../models/NotificationTemplate";
import { NotificationParams } from "../../models/NotificationParams";
import { UserStatus } from "@/modules/User/models/UserStatus";
import { EmailData } from "@/modules/Email/models/EmailData";
import { DocumentDTO } from "@/modules/Document/models/DocumentDTO";
import lodash from "lodash";
import { Dependency } from "@/modules/Dependencies/models/Dependency";
import { BasicObject } from "@/shared/constants/BasicObject";
import { MultimediaSelected } from "@/shared/components/MultimediaManager/models/MultimediaSelected.model";
import { FILTERS_NAMES_CONST } from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import {
  EVENT,
  ICONS_COLORS,
  MAIN_FILTER
} from "@/modules/Events/constants/EventConstants";
import TooltipButton from "@/shared/components/TooltipButton/TooltipButton.vue";
import { DocumentBasicData } from "@/modules/Document/models/DocumentBasicData";
import { IMG_TYPE_EXTENSIONS } from "@/shared/constants/FileConstants";
import {
  DOCUMENT,
  GOOGLE_DRIVE_URL
} from "@/modules/Document/constants/DocumentConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";

Vue.use(Vuetify);

@Component({
  name: "NotificationModal",
  components: {
    TooltipButton,
    ModalTemplate,
    InitialConfiguration,
    MessageConfiguration,
    MessageRecipients
  }
})
export default class NotificationModal extends Vue {
  @Prop({ default: false }) dialog!: boolean;
  @Prop({ default: "" }) userId?: string;
  @Prop() isEditing!: boolean;
  @Prop() editingNotification!: NotificationConfig;
  @Prop({ default: false }) tracing!: boolean;
  @Prop({ default: false }) isScheduledAvailable!: boolean;
  @Prop({ default: false }) isDocumentAvailable!: boolean;
  @Prop({ default: false }) isOnlyDocument!: boolean;
  @Prop() defaultDocument!: DocumentDTO;
  @Prop({ default: "" }) notificationModalType!: string;
  @Prop({ default: "" }) taskState!: string;
  @Prop({ default: false }) stateEditNotification!: boolean;
  @Prop() userInfoParams!: NotificationParams[];
  @Prop({ default: "" }) collection!: string;
  @Prop() isOnline?: boolean;
  @Prop({ default: "" }) fireNotificationModalMsg?: string;
  @Prop({ default: () => [] }) formTemplates?: string[];

  TITLE = NOTIFICATION_CONFIG.TITLE;
  SAVE_BUTTON = FORM_CONSTANTS.BUTTON.SAVE;
  SEND_BUTTON = FORM_CONSTANTS.BUTTON.SEND;
  CLOSE_BUTTON = FORM_CONSTANTS.BUTTON.CLOSE;

  BTN_HINT = EVENT.BTN_HINT;
  DOCUMENT = MAIN_FILTER.DOCUMENT;
  basicBtnClassRound = STYLE_CLASSES.BASIC_ROUND_BTN;
  ICON_COLORS = ICONS_COLORS;

  cardClass = STYLE_CLASSES.CARD;
  secondaryCardClass = STYLE_CLASSES.CARD_2;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryButtonClass = STYLE_CLASSES.SECONDARY_BTN;
  roundBtnClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  roundBtnClassSecondary = STYLE_CLASSES.SECONDARY_ROUND_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  btnClassPrimaryRound = STYLE_CLASSES.BASIC_ROUND_BTN;

  channels = NOTIFICATION_CONFIG.CHANNELS;
  serviceParams: NotificationParams[] = NOTIFICATION_CONFIG.SERVICE_PARAMS;
  orderParams: NotificationParams[] = NOTIFICATION_CONFIG.ORDER_PARAMS;
  generalParams: NotificationParams[] = NOTIFICATION_CONFIG.GENERAL_PARAMS;
  userParams: NotificationParams[] = NOTIFICATION_CONFIG.USER_PARAMS;
  medicalAppointmentParams: NotificationParams[] =
    NOTIFICATION_CONFIG.MEDICAL_APPOINTMENT_PARAMS;
  taskParams: NotificationParams[] = NOTIFICATION_CONFIG.TASK_PARAMS;
  sessionParams: NotificationParams[] = NOTIFICATION_CONFIG.SESSION_PARAMS;

  regex = NOTIFICATION_CONFIG.REGEX_BODY;

  SEND_DOCUMENT = NOTIFICATION_CONFIG.LABEL.SEND_DOCUMENT;
  WHATSAPP_TEMPLATE_HINT = NOTIFICATION_CONFIG.HINT.WHATSAPP_TEMPLATE;
  DOCUMENT_TEMPLATE_LABEL = NOTIFICATION_CONFIG.LABEL.DOCUMENT_TEMPLATE;
  INITIAL_CONFIG_TEXT = NOTIFICATION_CONFIG.LABEL.INITIAL_CONFIG_TEXT;
  MSG_DATA_TEXT = NOTIFICATION_CONFIG.LABEL.MSG_DATA_TEXT;
  RECEIVERS_TEXT = NOTIFICATION_CONFIG.LABEL.RECEIVERS_TEXT;
  CLEAN_NOTIFICATION = NOTIFICATION_CONFIG.LABEL.CLEAN_NOTIFICATION;

  textfieldValidation = false;
  isEditingComponents = false;
  formKey = 0;
  updateMessage = 0;
  resetComponents = 0;
  fields = FIELDS_INIT;
  isDocument = false;
  isViewer = false;
  confirmationDialog = false;
  isMappingData = false;
  isMappingComponents = {
    initConfig: false,
    messageConfig: false,
    recipientsConfig: false
  };
  documentPickerDialog = false;
  modalConfirmationTitle = "";
  modalConfirmationText = "";
  editingEvent = 0;
  notificationConfig: NotificationConfig = lodash.cloneDeep(
    NOTIFICATION_CONFIG_INIT
  );

  notificationFormValidation = false;

  chosenWhatsappTemplate: NotificationTemplate | string = "";
  paramsList: NotificationParams[] = [];

  shouldRestrictField = false;
  activeButtonSave = false;
  multipleRecipients = false;
  whatsAppValidated = false;
  editComparationStr = "";
  invalidEdit = false;
  mounted() {
    this.loadParamList();
    this.editNotification();
    this.isDocument = this.isOnlyDocument;
  }
  @Watch("notificationConfig", { deep: true })
  checkEdit() {
    if (this.isEditing) {
      this.invalidEdit =
        JSON.stringify({
          configuration: this.notificationConfig,
          fields: this.fields
        }) === this.editComparationStr;
    }
  }

  @Watch("isOnline")
  async validateOnlineStatus(newVal: boolean) {
    if (newVal != undefined && newVal == false && this.dialog) {
      this.modalConfirmationTitle =
        FORM_MESSAGES.WHATSAPP_SESSION_CHANGED.TITLE;
      this.modalConfirmationText =
        FORM_MESSAGES.WHATSAPP_SESSION_CHANGED.MESSAGE;
      this.confirmationDialog = true;
    } else if (this.dialog && newVal == true) {
      this.whatsAppValidated = true;
      this.acceptNotification();
    }
  }

  @Watch("fireNotificationModalMsg")
  async fireNotificationResultModal() {
    if (this.fireNotificationModalMsg && this.fireNotificationModalMsg != "") {
      this.modalConfirmationTitle = FORM_MESSAGES.INFO_MESSAGE.INFO_TITLE;
      this.modalConfirmationText = this.fireNotificationModalMsg;
      this.confirmationDialog = true;
    }
  }

  @Watch("isEditing")
  async editNotification() {
    if (this.isEditing) {
      this.invalidEdit = true;
      this.isDocument = false;
      this.isMappingData = true;
      this.isMappingComponents.initConfig = true;
      this.isMappingComponents.messageConfig = true;
      this.isMappingComponents.recipientsConfig = true;
      this.notificationConfig = lodash.cloneDeep(this.editingNotification);
      if (this.editingNotification.notification.idNotification) {
        this.shouldRestrictField =
          this.editingNotification.notification.idNotification === ""
            ? false
            : true;
      }
      this.fields = {
        emailFields: this.notificationConfig.notification.channels
          ? this.notificationConfig.notification.channels.includes(
              NOTIFICATION_CONFIG.CHANNEL_TEXT.EMAIL
            )
          : false,
        whatsappFields: this.notificationConfig.notification.channels
          ? this.notificationConfig.notification.channels.includes(
              NOTIFICATION_CONFIG.CHANNEL_TEXT.WHATSAPP
            )
          : false,
        pushFields: this.notificationConfig.notification.channels
          ? this.notificationConfig.notification.channels.includes(
              NOTIFICATION_CONFIG.CHANNEL_TEXT.PUSH
            )
          : false,
        smsFields: this.notificationConfig.notification.channels
          ? this.notificationConfig.notification.channels.includes(
              NOTIFICATION_CONFIG.CHANNEL_TEXT.SMS
            )
          : false,
        webhookFields: this.notificationConfig.notification.channels
          ? this.notificationConfig.notification.channels.includes(
              NOTIFICATION_CONFIG.CHANNEL_TEXT.WEBHOOK
            )
          : false
      };
      this.isEditingComponents = true;
      this.editingEvent = 1 - this.editingEvent;
      this.activeButtonSave = true;
    } else {
      this.isEditingComponents = false;
      this.clearFields();
    }
  }

  @Watch("dialog", { deep: true })
  loadParamList() {
    switch (this.collection) {
      case FILTERS_NAMES_CONST.ORDER.NAME:
        this.paramsList = [];
        this.paramsList.push(
          ...this.userInfoParams,
          ...this.orderParams,
          ...this.generalParams
        );
        break;
      case FILTERS_NAMES_CONST.SERVICE.NAME:
        this.paramsList = [];
        this.paramsList.push(
          ...this.userInfoParams,
          ...this.serviceParams,
          ...this.generalParams
        );
        break;
      case FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.NAME:
        this.paramsList = [];
        this.paramsList.push(
          ...this.userInfoParams,
          ...this.medicalAppointmentParams,
          ...this.generalParams
        );
        break;
      case FILTERS_NAMES_CONST.SESSION.NAME:
        this.paramsList = [];
        this.paramsList.push(
          ...this.userInfoParams,
          ...this.sessionParams,
          ...this.generalParams
        );
        break;
      case FILTERS_NAMES_CONST.TASK.NAME:
        this.paramsList = [];
        this.paramsList.push(
          ...this.userInfoParams,
          ...this.taskParams,
          ...this.generalParams
        );
        break;
      case FILTERS_NAMES_CONST.USER.NAME:
        this.paramsList = [];
        this.paramsList.push(
          ...this.userInfoParams,
          ...this.userParams,
          ...this.generalParams
        );
        break;
      default:
        this.paramsList = [];
        this.paramsList = this.userInfoParams;
        break;
    }
  }

  @Watch("fields")
  async fieldsUpdated() {
    if (this.defaultDocument?.documentPath != undefined) {
      this.notificationConfig.notification.message.type =
        WHATSAPP_TEMPLATE_TYPES.IMAGE;
    }
    this.checkEdit();
  }

  @Watch("isDocument")
  async isDocumentUpdated() {
    this.notificationConfig.time = "";
    this.notificationConfig.startDate = null;
    this.notificationConfig.notification.frequency = 0;
    this.notificationConfig.notification.message.params = [];
    this.notificationConfig.notification.message.body = "";
    this.notificationConfig.notification.message.template = "";
  }

  get canEditRestrictedField() {
    return this.stateEditNotification && this.shouldRestrictField;
  }

  clearFields() {
    this.notificationConfig = lodash.cloneDeep(NOTIFICATION_CONFIG_INIT);
    this.fields = FIELDS_INIT;
    this.chosenWhatsappTemplate = "";
    this.stateEditNotification = false;
    this.shouldRestrictField = false;
    this.activeButtonSave = false;
    this.multipleRecipients = false;
    if (!this.isOnlyDocument) {
      this.isDocument = false;
    }
    this.updateMessageType(NOTIFICATION_CONFIG.MSG_TYPES[0].value);
    this.resetComponents = 1 - this.resetComponents;
    this.formKey = 1 - this.formKey;
  }

  acceptNotification() {
    if (this.notificationModalType == NOTIFICATION_MODAL_TYPE.SAVE) {
      if (
        this.notificationConfig.recipients.defaultRecipients.length === 0 &&
        this.notificationConfig.recipients.dependencyUsers.length === 0 &&
        this.notificationConfig.recipients.dependencies.length === 0
      ) {
        this.modalConfirmationTitle = FORM_MESSAGES.ERROR.TITLE;
        this.modalConfirmationText = FORM_MESSAGES.ERROR.TEXT;
      } else {
        this.modalConfirmationTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
        this.modalConfirmationText =
          FORM_MESSAGES.SAVE_MODAL.MESSAGE + this.getMessageModalConfirm();
      }
    } else if (
      this.notificationModalType == NOTIFICATION_MODAL_TYPE.SEND ||
      this.notificationModalType == NOTIFICATION_MODAL_TYPE.MULTIPLE_ACTION
    ) {
      if (this.isOnline && !this.whatsAppValidated) {
        const whatsappPresent = this.notificationConfig.notification.channels?.includes(
          NOTIFICATION_CONFIG.CHANNEL_TEXT.WHATSAPP
        );
        if (whatsappPresent) {
          this.$emit(NOTIFICATION_EVENTS.VALIDATE_FREE_WHATSAPP);
          return;
        }
      }
      const smsChannelExceed =
        this.notificationConfig.notification.channels?.includes(
          NOTIFICATION_CONFIG.CHANNEL_TEXT.SMS
        ) && this.notificationConfig.notification.message.body.length > 160;
      if (smsChannelExceed) {
        this.modalConfirmationTitle = FORM_MESSAGES.SMS_LIMIT_EXCEEDED.TITLE;
        this.modalConfirmationText = FORM_MESSAGES.SMS_LIMIT_EXCEEDED.MESSAGE;
      } else {
        this.modalConfirmationTitle = FORM_MESSAGES.SEND_MODAL.TITLE;
        this.modalConfirmationText =
          FORM_MESSAGES.SEND_MODAL.MESSAGE + this.getMessageModalConfirm();
      }
    } else if (this.notificationModalType == NOTIFICATION_MODAL_TYPE.TASK) {
      this.modalConfirmationTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
      this.modalConfirmationText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
    }
    this.confirmationDialog = true;
    this.whatsAppValidated = false;
  }

  getMessageModalConfirm() {
    const startDate = this.notificationConfig.startDate || 0;
    const frequency = this.notificationConfig.notification.frequency || 0;
    const time = this.notificationConfig.time || "";
    const scheduleData = {
      startDate: startDate,
      frequency: frequency,
      time: time
    };
    let message = "";
    if (startDate == 0 && frequency == 0 && time == "") {
      message = MESSAGES.IMMEDIATE_MESSAGE;
    } else if (startDate == 0 && frequency && frequency > 0 && time == "") {
      message = this.mapKeysMessage(scheduleData, MESSAGES.FREQUENCY_MESSAGE);
    } else if (startDate == 0 && frequency && frequency > 0 && time != "") {
      message = this.mapKeysMessage(
        scheduleData,
        MESSAGES.FREQUENCY_HOUR_MESSAGE
      );
    } else if (
      startDate &&
      startDate > 0 &&
      frequency &&
      frequency > 0 &&
      time != ""
    ) {
      message = this.mapKeysMessage(
        scheduleData,
        MESSAGES.SCHEDULED_FRECUENCY_HOUR_MESSAGE
      );
    } else if (
      startDate &&
      startDate > 0 &&
      frequency &&
      frequency > 0 &&
      time == ""
    ) {
      message = this.mapKeysMessage(
        scheduleData,
        MESSAGES.SCHEDULED_FRECUENCY_MESSAGE
      );
    } else if (startDate && startDate > 0 && frequency == 0 && time == "") {
      message = this.mapKeysMessage(scheduleData, MESSAGES.SCHEDULED_MESSAGE);
    } else if (startDate && startDate > 0 && frequency == 0 && time != "") {
      message = this.mapKeysMessage(
        scheduleData,
        MESSAGES.SCHEDULED_HOUR_MESSAGE
      );
    } else if (startDate == 0 && frequency == 0 && time != "") {
      message = this.mapKeysMessage(scheduleData, MESSAGES.HOUR_MESSAGE);
    }
    return message;
  }

  mapKeysMessage(
    scheduleData: {
      startDate: number;
      frequency: number;
      time: string;
    },
    message: string
  ) {
    (Object.keys(scheduleData) as (keyof typeof scheduleData)[]).forEach(
      key => {
        message = message.replace("{" + key + "}", scheduleData[key] + "");
      }
    );
    return message;
  }

  cancelNotification() {
    this.$emit(NOTIFICATION_EVENTS.CANCEL);
    this.clearFields();
  }

  updateName(name: string) {
    this.notificationConfig.name = name;
  }

  updateChannels(
    channels: string[],
    whatsappFields: boolean,
    smsFields: boolean,
    pushFields: boolean,
    emailFields: boolean,
    webhookFields: boolean,
    channelsChosenKeys: { name: string; value: string; key: string }[]
  ) {
    this.notificationConfig.notification.channels = channels;
    this.notificationConfig.notification.channelsKeys = channelsChosenKeys;
    this.fields = {
      whatsappFields: whatsappFields,
      pushFields: pushFields,
      smsFields: smsFields,
      emailFields: emailFields,
      webhookFields: webhookFields
    };
    this.notificationConfig.notification.message.type =
      NOTIFICATION_CONFIG.MSG_TYPES[0].value;

    this.notificationConfig.notification.message.category =
      NOTIFICATION_CONFIG.MSG_CATEGORIES[0].value;

    this.updateMessage = 1 - this.updateMessage;
  }

  updateMessageType(messageType: string) {
    if (this.defaultDocument?.documentPath != undefined) return;
    this.notificationConfig.notification.message.type = messageType;
    this.updateMessage = 1 - this.updateMessage;
  }

  async updateMessageCategory(messageCategory: string) {
    this.notificationConfig.notification.message.category = messageCategory;
    this.updateMessage = 1 - this.updateMessage;
  }

  updateTime(time: string) {
    this.notificationConfig.time = time;
  }

  updateDate(startDate: number | null) {
    this.notificationConfig.startDate = startDate;
  }

  updateFrequency(frequency: number | null) {
    if (frequency != null && frequency != undefined) {
      this.notificationConfig.notification.frequency = frequency;
    } else {
      delete this.notificationConfig.notification.frequency;
    }
  }
  updateTimes(times: number | null) {
    if (times != null && times != undefined) {
      this.notificationConfig.notification.times = times;
    } else {
      delete this.notificationConfig.notification.times;
    }
    this.checkEdit();
  }

  updatedTitle(title: string) {
    this.notificationConfig.notification.message.title = title;
  }

  updatedBody(body: string) {
    this.notificationConfig.notification.message.body = body;
  }

  updatedButtonParams(buttonParams: string) {
    this.notificationConfig.notification.message["button_params"] = [
      buttonParams
    ];
  }

  updateMultimedia(multimedia: MultimediaSelected) {
    this.notificationConfig.notification.message.multimedia = multimedia;
  }

  updatedParams(params: NotificationParams[], quantityParams: number) {
    this.notificationConfig.notification.message.params = params;
    let active = true;
    if (this.notificationConfig.notification.message.template) {
      active = quantityParams > 0 && quantityParams == params.length;
    }
    this.activeButtonSave = active;
    if (!this.multipleRecipients) this.activeButtonSave = true;
    this.checkEdit();
  }

  updatedTemplate(templateChosen: NotificationTemplate) {
    this.notificationConfig.notification.message.template = templateChosen;
    if (this.isDocument) {
      let appCategory = WHATSAPP_DOCUMENT_CATEGORY;
      if (templateChosen) {
        this.notificationConfig.notification.message.type =
          templateChosen.templateType;
        if (templateChosen.appCategory) {
          appCategory =
            templateChosen.appCategory.length > 0
              ? templateChosen.appCategory[0]
              : "";
        }
      }
      this.notificationConfig.notification.message.category = appCategory;
    }
  }

  updatedImage(image: MultimediaSelected) {
    this.notificationConfig.notification.message.image = image;
  }

  updatedVideo(video: MultimediaSelected) {
    this.notificationConfig.notification.message.video = video;
  }

  updatedFile(file: string) {
    this.notificationConfig.notification.message.file = file;
  }

  updatedLatitude(latitude: string) {
    this.notificationConfig.notification.message.latitude = latitude;
  }

  updatedLongitude(longitude: string) {
    this.notificationConfig.notification.message.longitude = longitude;
  }

  updateDefault(defaultRecipients: string[]) {
    this.notificationConfig.recipients.defaultRecipients = defaultRecipients;
  }

  updateDependencies(dependencies: Dependency[]) {
    this.notificationConfig.recipients.dependencies = dependencies;
  }

  updateDependencyUsers(dependencyUsers: UserStatus[]) {
    this.notificationConfig.recipients.dependencyUsers = dependencyUsers;
  }

  updatedEmail(email: EmailData) {
    this.notificationConfig.notification.message.emailSender = email;
  }

  updatedWebhook(webhook: string) {
    this.notificationConfig.notification.message.webhook = webhook;
  }

  updatedFormFields(formFields: string[]) {
    this.notificationConfig.notification.message.formFields = formFields;
  }

  updateInmediate(isInmediate: boolean) {
    this.notificationConfig.time = "";
    this.notificationConfig.notification.isScheduledNotification = isInmediate;
  }

  confirmationAccept() {
    this.confirmationDialog = false;
    if (this.isEditing) {
      if (
        this.modalConfirmationTitle === FORM_MESSAGES.SAVE_MODAL.TITLE ||
        this.modalConfirmationTitle === FORM_MESSAGES.SEND_MODAL.TITLE ||
        this.modalConfirmationTitle === FORM_MESSAGES.SEND_MODAL.TITLE
      ) {
        this.mapNotificationConfig();
        this.$emit(NOTIFICATION_EVENTS.EDITED, this.notificationConfig);
        this.clearFields();
      } else if (
        this.modalConfirmationTitle ===
        NOTIFICATION_CONFIG.DIALOG_MSG.CLEAN.TITLE
      ) {
        this.clearFields();
      }
    } else {
      if (
        this.modalConfirmationTitle === FORM_MESSAGES.SAVE_MODAL.TITLE ||
        this.modalConfirmationTitle === FORM_MESSAGES.SEND_MODAL.TITLE
      ) {
        this.mapNotificationConfig();
        this.$emit(NOTIFICATION_EVENTS.ACCEPT, this.notificationConfig);
        this.clearFields();
      } else if (
        this.modalConfirmationTitle ===
        NOTIFICATION_CONFIG.DIALOG_MSG.CLEAN.TITLE
      ) {
        this.clearFields();
      } else if (
        this.modalConfirmationTitle === FORM_MESSAGES.SMS_LIMIT_EXCEEDED.TITLE
      ) {
        this.notificationConfig.notification.channels?.splice(
          this.notificationConfig.notification.channels.findIndex(
            item => item == NOTIFICATION_CONFIG.CHANNEL_TEXT.SMS
          ),
          1
        );
        this.mapNotificationConfig();
        this.$emit(NOTIFICATION_EVENTS.ACCEPT, this.notificationConfig);
        this.clearFields();
      }
    }
  }

  mapNotificationConfig() {
    const emailFieldsExist = Boolean(this.fields.emailFields);
    const emailSenderIsString =
      typeof this.notificationConfig.notification.message.emailSender ===
      "string";
    const messageTemplate = this.notificationConfig.notification.message
      .template;
    if (
      (this.notificationConfig.notification.message.multimedia &&
        this.notificationConfig.notification.channels?.includes(
          NOTIFICATION_CONFIG.CHANNEL_TEXT.PUSH
        )) ||
      (this.notificationConfig.notification.message.multimedia &&
        this.notificationConfig.notification.channels?.includes(
          NOTIFICATION_CONFIG.CHANNEL_TEXT.EMAIL
        ))
    ) {
      const newBodyMessage = `${this.notificationConfig.notification.message.body} ${NOTIFICATION_MESSAGES_BODY.TEXT_URL} ${this.notificationConfig.notification.message.multimedia.multimediaPath}`;
      this.notificationConfig.notification.message.body = newBodyMessage;
      if (this.notificationConfig.notification.message.multimedia._key === "") {
        delete this.notificationConfig.notification.message.multimedia;
      }
    }
    if (
      this.notificationConfig.notification.message.video &&
      this.notificationConfig.notification.message.video._key === ""
    ) {
      delete this.notificationConfig.notification.message.video;
    }

    if (
      this.notificationConfig.notification.message.image &&
      this.notificationConfig.notification.message.image._key === ""
    ) {
      delete this.notificationConfig.notification.message.image;
    }
    if (this.notificationConfig.notification.message.file === "") {
      delete this.notificationConfig.notification.message.file;
    }
    if (this.notificationConfig.notification.message.latitude === "") {
      delete this.notificationConfig.notification.message.latitude;
    }
    if (this.notificationConfig.notification.message.longitude === "") {
      delete this.notificationConfig.notification.message.longitude;
    }

    if (this.notificationModalType === NOTIFICATION_MODAL_TYPE.SAVE) {
      this.notificationConfig.recipients.defaultRecipients = (this
        .notificationConfig.recipients.defaultRecipients as BasicObject[]).map(
        user => user ?? ""
      );
      this.notificationConfig.recipients.dependencyUsers = (this
        .notificationConfig.recipients.dependencyUsers as UserStatus[]).map(
        user => user.id
      );
      this.notificationConfig.recipients.dependencies = (this.notificationConfig
        .recipients.dependencies as Dependency[]).map(template =>
        template.id ? template.id : ""
      );
    }

    if (messageTemplate && typeof messageTemplate !== "string") {
      this.notificationConfig.notification.message.template = (messageTemplate as NotificationTemplate).id;
      this.notificationConfig.notification.message.originalTemplate =
        messageTemplate.data;
    }

    if (emailFieldsExist && !emailSenderIsString) {
      const emailSenderId = (this.notificationConfig.notification.message
        .emailSender as EmailData).id;
      this.notificationConfig.notification.message.emailSender = emailSenderId;
    }

    if (
      this.notificationConfig.notification.channels?.includes(
        NOTIFICATION_CONFIG.CHANNEL_TEXT.SMS
      ) ||
      this.notificationConfig.notification.channels?.includes(
        NOTIFICATION_CONFIG.CHANNEL_TEXT.WHATSAPP
      ) ||
      this.notificationConfig.notification.channels?.includes(
        NOTIFICATION_CONFIG.CHANNEL_TEXT.WEBHOOK
      )
    ) {
      this.notificationConfig.notification.message.title = this.notificationConfig.name!;
    }
  }

  cleanFieldsModal() {
    this.modalConfirmationText = NOTIFICATION_CONFIG.DIALOG_MSG.CLEAN.TEXT;
    this.modalConfirmationTitle = NOTIFICATION_CONFIG.DIALOG_MSG.CLEAN.TITLE;
    this.confirmationDialog = true;
  }

  confirmationCancel() {
    this.confirmationDialog = false;
  }

  @Watch("isMappingComponents", { deep: true })
  dataMapped() {
    if (
      !this.isMappingComponents.initConfig &&
      !this.isMappingComponents.messageConfig &&
      !this.isMappingComponents.recipientsConfig
    ) {
      this.editComparationStr = JSON.stringify({
        configuration: this.notificationConfig,
        fields: this.fields
      });
      this.isMappingData = false;
    }
  }

  initialConfigurationMapped() {
    this.isMappingComponents.initConfig = false;
  }

  messageConfigurationMapped() {
    this.isMappingComponents.messageConfig = false;
  }

  recipientsConfigurationMapped() {
    this.isMappingComponents.recipientsConfig = false;
  }

  updateMultipleRecipients(value: boolean) {
    this.activeButtonSave = value;
  }

  isReminderNotification(isReminder: boolean) {
    this.notificationConfig.notification.isReminder = isReminder;
    if (isReminder) {
      delete this.notificationConfig.notification.frequency;
      this.notificationConfig.time = "";
    }
  }

  @Watch("defaultDocument", { deep: true })
  viewDefaultDocument() {
    if (this.defaultDocument != undefined || this.defaultDocument != null) {
      this.defaultDocument.documentPath
        ? (this.isViewer = true)
        : (this.isViewer = false);
    }
  }

  showPreview() {
    const documentBasicData: DocumentBasicData = {
      documentName: this.defaultDocument.fileName,
      documentURL: "",
      migrate: this.defaultDocument.migrate
    };
    if (this.defaultDocument.documentPath) {
      this.isViewer = true;

      if (documentBasicData.migrate) {
        documentBasicData.documentURL = this.defaultDocument
          .documentPathSigned as string;
        this.$emit(DOCUMENT.EVENT.SHOW, documentBasicData);
        return;
      }

      if (IMG_TYPE_EXTENSIONS.includes(this.defaultDocument.type)) {
        documentBasicData.documentURL = this.defaultDocument.documentPath;
      } else {
        const encodedURI = encodeURIComponent(
          this.defaultDocument.documentPath
        );
        documentBasicData.documentURL = `${GOOGLE_DRIVE_URL}${encodedURI}`;
      }

      this.$emit(DOCUMENT.EVENT.SHOW, documentBasicData);
    } else {
      Snackbar.popError(DOCUMENT.MESSAGE.EMPTY_URL);
    }
  }

  updateParamsList(
    newParams: {
      collection: string | undefined;
      name: string;
      id: string;
      editable: boolean;
    }[]
  ) {
    this.paramsList = newParams;
  }

  cloneThis(notificationConfig: NotificationConfig) {
    return lodash.cloneDeep(notificationConfig);
  }
}
